import React, { useState } from "react";
import _ from "lodash/fp";

import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Autocomplete, {
  createFilterOptions,
} from "@material-ui/lab/Autocomplete";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { Controller } from "react-hook-form";

import { request } from "../../../../services/helpers";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const labelClass =
  "block tracking-wide text-black font-display text-sm leading-5 font-medium mb-2";

const filter = createFilterOptions();

export const MuiItemAutoComplete = (props) => {
  const {
    control,
    options,
    name,
    autoComplete,
    customChangeCB,
    onAddNewItem,
  } = props;

  const [dialogValue, setDialogValue] = useState({
    name: "",
    rate: 0,
    taxRate: 0,
  });
  const [value, setValue] = useState(null);
  const [open, toggleOpen] = useState(false);
  const [openSnackbar, snackbarOpener] = useState(false);
  const [errors, setError] = useState({});
  const [RequestError, setRequestError] = useState("");
  const [itemType, setItemType] = useState("additionalService");

  const validateForm = (errors) => {
    let valid = true;
    Object.values(errors).forEach(
      // if we have an error string set valid to false
      (val) => val.length > 0 && (valid = false)
    );
    return valid;
  };

  const handleChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    let newErrors = { ...errors };

    switch (name) {
      case "name":
        newErrors.errorAtName =
          value.trim().length < 3
            ? "Item Name must be atlesat 3 characters long."
            : "";
        break;
      case "rate":
        newErrors.errorAtRate =
          Number(value) < 0 || !value.length
            ? "Rate should be a positive number."
            : "";
        break;
      case "taxRate":
        newErrors.errorAtTaxRate =
          Number(value) < 0 || !value.length
            ? "Tax should be a positive number."
            : "";
        break;
      default:
        break;
    }
    // Set Error and Field states.
    setError(newErrors);
    setDialogValue({ ...dialogValue, [name]: value });
  };

  const handleItemTypeChange = (event) => {
    setItemType(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!validateForm(errors)) {
      setRequestError("Please correct the above errors and submit.");
      return;
    }

    // Send API Request to add a new product, Add it to options array and select it.
    try {
      const res = await request.post("/products", {
        name: dialogValue.name,
        rateType: "Rupees",
        rate: dialogValue.rate,
        type: itemType,
        taxRate: dialogValue.taxRate,
      });

      if (res.status !== 201) {
        // console.log("Request-Err: ", res.error);
        setRequestError(
          res.error.message || res.error || "Something went wrong."
        );
        return;
      }

      // Close the modal
      handleCancel();

      // Open Snackbar
      snackbarOpener(true);

      // Product addition to productList
      onAddNewItem(res.data);

      // AutoComplete controll value
      setValue(res.data);

      // Controller element onChange ref.
      dialogValue.controllerOnChange(res.data);

      // To alter selected Product with new Rate,Tax and Amount.
      customChangeCB(res.data);
    } catch (error) {
      setRequestError(error.message || "Something went wrong.");
    }
  };

  const handleCancel = () => {
    // props.setFormValue(`itemList[0].product`, null);
    setError({});
    setDialogValue({
      name: "",
      rate: 0,
      taxRate: 0,
    });
    setRequestError("");
    setItemType("additionalService");

    toggleOpen(false);
  };

  const handleSnackbarClick = () => {
    snackbarOpener(true);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    snackbarOpener(false);
  };

  return (
    <React.Fragment>
      <Controller
        {...props}
        name={name}
        control={control}
        render={({ onChange }) => {
          return (
            <Autocomplete
              value={value}
              onChange={(event, newValue) => {
                if (typeof newValue === "string") {
                  // timeout to avoid instant validation of the dialog's form.
                  setTimeout(() => {
                    toggleOpen(true);
                    setDialogValue({
                      name: newValue,
                      rate: 0,
                      taxRate: 0,
                    });
                  });
                } else if (newValue && newValue.inputValue) {
                  toggleOpen(true);
                  setDialogValue({
                    name: newValue.inputValue,
                    rate: 0,
                    taxRate: 0,
                    controllerOnChange: onChange,
                  });
                  if (newValue.inputValue.length < 3) {
                    const errorAtName =
                      "Item Name must be atlesat 3 characters long.";
                    setError({ ...errors, errorAtName });
                  }
                } else {
                  // Set AutoComplete elem. value.
                  setValue(newValue);

                  //Controller element onChange Ref.
                  onChange(newValue);

                  //Pass data to parent WatchItemsList.
                  customChangeCB(newValue);
                }
              }}
              filterOptions={(options, params) => {
                const filtered = filter(options, params);

                if (params.inputValue.trim().length > 0) {
                  filtered.push({
                    inputValue: params.inputValue,
                    name: `Add  "${params.inputValue}"`,
                  });
                }

                return filtered;
              }}
              // autoComplete={autoComplete}
              selectOnFocus
              clearOnBlur
              handleHomeEndKeys
              options={options}
              getOptionLabel={(option) => {
                if (typeof option === "string") {
                  return option;
                }
                if (option.inputValue) {
                  return option.inputValue;
                }

                return option.name;
              }}
              renderOption={(option) => {
                return <span>{option.name}</span>;
              }}
              getOptionSelected={(option, name) => {
                return _.isEqual(option, name);
              }}
              renderInput={(params) => (
                <div className="flex items-center" ref={params.InputProps.ref}>
                  <div className="w-full">
                    <TextField
                      {...params}
                      {...props.inputProps}
                      style={{
                        backgroundColor: "white",
                      }}
                      variant="outlined"
                    />
                  </div>
                </div>
              )}
            />
          );
        }}
      />
      <Dialog
        className="rounded-lg"
        open={open}
        onClose={handleCancel}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          <div className="mt-3">
            <h2 className="font-bold text-4xl leading-10">Add a new item</h2>
          </div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Did we miss any item in our list? Please add it!
          </DialogContentText>
          <div className="pt-5">
            <label className={labelClass} htmlFor="item-name">
              Item Type
            </label>
            <RadioGroup
              row
              aria-label="Item Type"
              name="itemType"
              value={itemType}
              onChange={handleItemTypeChange}
            >
              <FormControlLabel
                value="additionalService"
                control={<Radio />}
                label="Additional Service"
              />
              <FormControlLabel
                value="membership"
                control={<Radio />}
                label="Membership Item"
              />
              <FormControlLabel value="none" control={<Radio />} label="None" />
            </RadioGroup>
          </div>
          <div className="md:flex mt-5 align-center justify-around">
            <div className="md:w-3/5 w-full mb-3">
              <label className={labelClass} htmlFor="item-name">
                Item Name
              </label>
              <TextField
                // className={classNames({
                //   [inputClass]: true,
                //   [inputErrorClass]: errors.spocName && errors.spocName.message,
                // })}
                autoFocus
                value={dialogValue.name}
                onChange={handleChange}
                fullWidth
                margin="dense"
                id="item-name"
                type="text"
                placeholder="Item Name"
                name="name"
                variant="outlined"
              />
              {errors.errorAtName && (
                <div className="text-xs text-red-500 flex flex-row-reverse">
                  <span>{errors.errorAtName}</span>
                </div>
              )}
            </div>

            <div className="md:w-1/5 w-full mb-3 md:ml-3">
              <label className={labelClass} htmlFor="rate-per-unit">
                Rate/Unit
              </label>
              <TextField
                value={dialogValue.rate}
                onChange={handleChange}
                fullWidth
                margin="dense"
                id="rate-per-unit"
                inputProps={{ type: "number", min: 0 }}
                // type="number"
                placeholder="Rate/Unit"
                name="rate"
                variant="outlined"
                defaultValue={0}
              />
              {errors.errorAtRate && (
                <div className="text-xs text-red-500 flex flex-row-reverse">
                  <span>{errors.errorAtRate}</span>
                </div>
              )}
            </div>

            <div className="md:w-1/5 w-full mb-3 md:ml-3">
              <label className={labelClass} htmlFor="tax">
                Tax( % )
              </label>
              <TextField
                value={dialogValue.taxRate}
                onChange={handleChange}
                fullWidth
                margin="dense"
                id="tax"
                inputProps={{ type: "number", min: 0 }}
                // type="number"
                placeholder="Tax"
                name="taxRate"
                // label="Tax"
                variant="outlined"
                defaultValue={0}
              />
              {errors.errorAtTaxRate && (
                <div className="text-xs text-red-500 flex flex-row-reverse">
                  <span>{errors.errorAtTaxRate}</span>
                </div>
              )}
            </div>
          </div>
          <hr className="border-b-1 border-gray-400 mt-5" />
          {RequestError && (
            <div className="text-xs text-red-700 flex flex-row mt-2">
              <span>*{RequestError}</span>
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            className="mb-5 border-gray-500 shadow rounded-md uppercase md:px-12 px-5 py-3 font-semibold text-sm leading-2 tracking-wide outline-none"
            onClick={handleCancel}
            // color="primary"
          >
            Cancel
          </Button>
          <Button
            className="md:ml-4 mr-4 mb-5 border-gray-500 shadow bg-yellow-400 rounded-md uppercase md:px-12 px-5 py-3 font-semibold text-sm leading-2 tracking-wide outline-none"
            onClick={handleSubmit}
            // color="primary"
          >
            Add Item
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        open={openSnackbar}
        onClose={handleSnackbarClose}
        autoHideDuration={5000}
      >
        <Alert severity="success">Item added successfully!</Alert>
      </Snackbar>
    </React.Fragment>
  );
};
